import { DEFAULT_BREAKPOINTS, DefaultBreakpoints, useAdaptiveValue } from '@platform-ui/media';

export const useBreakpoint = (breakpoint: keyof DefaultBreakpoints) => {
  const adaptive = useAdaptiveValue<DefaultBreakpoints>();

  const breakpointsQuery = Object.fromEntries(
    Object.keys(DEFAULT_BREAKPOINTS).map(key => [key, key === breakpoint]),
  ) as Record<keyof DefaultBreakpoints, boolean>;

  return adaptive(breakpointsQuery);
};
